import React from "react";
import * as FeatherIcon from "react-feather";
import "./DynamicStepper.css";
import GeneratingLoader from "./GeneratingLoader";

const DynamicStepper = ({
  stepsConfig = [],
  completedSteps = {},
  currentStepIndex,
  setCurrentStepIndex,
  compInitiating = false,
  campaignStartDate,
  today,
  campActive
}) => {
  const getStatus = (stepId, index) => {
    if (completedSteps[stepId]) return "completed";
    if (index === currentStepIndex) return "inprogress";
    return "pending";
  };

  const isCampaignPast = campaignStartDate < today;

  return (
    <div className="dynamic-stepper-wrapper">
      <div className="stepper-container">
        {stepsConfig.map((step, idx) => {
          const status = getStatus(step.id, idx);
          const isStriped = isCampaignPast || campActive? "striped" : "";

          return (
            <React.Fragment key={step.id}>
              {idx > 0 && (
                <div
                  className={`step-line ${getStatus(
                    stepsConfig[idx - 1].id,
                    idx - 1
                  )}-${status}`}
                />
              )}

              <div className="step-wrapper"                   
              onClick={() => {
                    if (isCampaignPast || isStriped) return;
                    const prevStep = stepsConfig[idx - 1];
                    const isPrevCompleted = prevStep
                      ? completedSteps[prevStep.id]
                      : true;
                    if (completedSteps[step.id] || isPrevCompleted) {
                      setCurrentStepIndex(idx);
                    }
                  }}>
                <div
                  className={`step-circle ${status} ${isStriped}`}

                >
                  {status === "completed" && (
                    <FeatherIcon.Check size={14} className="arrow" />
                  )}
                </div>

                <div className="step_label_container">
                  <div className={`step-title ${status}`}>
                    {idx + 1}. {step.title}
                  </div>
                </div>
              </div>
            </React.Fragment>
          );
        })}
      </div>

      <div className="step-content">
        {compInitiating ? (
          <div
            style={{
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              marginTop: "10rem",
            }}
          >
            <GeneratingLoader />
          </div>
        ) : (
          stepsConfig[currentStepIndex]?.component
        )}
      </div>
    </div>
  );
};

export default React.memo(DynamicStepper);
